const BASE_URL = 'https://dxbmap.emiratesauction.net/api/';

export async function getConfig() {
  try {
    const response = await fetch(`${BASE_URL}Common/GetConfig`);
    return await response.json();
  } catch (error) {
    return [];
  }
}
export async function GetCases() {
  try {
    const response = await fetch(`${BASE_URL}Common/GetCases`);
    return await response.json();
  } catch (error) {
    return [];
  }
}

export async function AddCase(data) {
  const response = await fetch(`${BASE_URL}Common/AddCase`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data),
  });
  let payload = null;
  try {
    payload = await response.json();
  } catch (error) {
    payload = null;
  }

  if (response.status !== 200) {
    const message =
      payload?.message ||
      payload?.title ||
      payload?.error ||
      `Add case failed with status ${response.status}`;
    throw new Error(message);
  }

  return payload;
}

export async function getMakaniDetails(makaniNumber, remarks = 'st') {
  try {
    const normalizedMakaniNumber = String(makaniNumber).replace(/\s+/g, '');
    const response = await fetch(
      `${BASE_URL}Common/GetMakaniDetails?makaniNo=${encodeURIComponent(
        normalizedMakaniNumber
      )}&remarks=${encodeURIComponent(remarks)}`
    );
    return await response.json();
  } catch (error) {
    return null;
  }
}
